import { defineNuxtPlugin } from '#imports'
import createKeyControlsService from '@services/key-controls-service'
import createPlayerService from '@services/player-service'
import createQueueService from '@services/queue-service'
import { keyControlsServiceKey } from '@composables/use-key-controls-service'
import { playerServiceKey } from '@composables/use-player-service'
import { queueServiceKey } from '@composables/use-queue-service'
import { useSettingsStore } from '@stores/settings'

export default defineNuxtPlugin({
    name: 'services',
    setup(nuxtApp) {
        const playerService = createPlayerService()
        const queueService = createQueueService({ playerService })
        const keyControlsService = createKeyControlsService(playerService, queueService)

        const settingsStore = useSettingsStore()

        playerService.setVolume(settingsStore.volume)
        playerService.on('settingsUpdate', settings => settingsStore.setSettings(settings))

        nuxtApp.vueApp.provide(playerServiceKey, playerService)
        nuxtApp.vueApp.provide(queueServiceKey, queueService)
        nuxtApp.vueApp.provide(keyControlsServiceKey, keyControlsService)
    },
})
